import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { StatisticsCardComponent } from '../statistics-card/statistics-card.component';

import { SharedModule } from '../../../shared-module';

@Component({
  selector: 'app-statistics-section-1',
  templateUrl: './statistics-section-1.component.html',
  styleUrl: './statistics-section-1.component.scss',
  imports: [StatisticsCardComponent, SharedModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatisticsSection1Component {}
